module.exports = __webpack_public_path__ + "assets/squarespace-commerce.b4665b0b.svg";